/* eslint-disable jsx-a11y/control-has-associated-label */
import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import styles from './TrackCompetitors.module.scss';
import { CreateTicket, handleImpressionsTrack } from '../../api';
import { useAuth } from '../../contexts/auth';
import {
  clickTracker,
  getProjectId,
  getSourceValue,
  getSubEventType,
  handleRedirection,
  hasJdMartVertical,
  touchSource,
  webSource,
} from '../../lib/common';
import useClickAwayListener from '../../hooks/useClickAwayLitsner';

function FeedbackPopup({ handleCloseFeedbackPopup, popupData, id, selectedType, faqId, trackerId, setAlert }) {
  const [authState] = useAuth();
  const { selectedBusiness, userDetails } = authState;
  const [isCreatingTicket, setIsCreatingTicket] = useState(false);
  const source = getSourceValue();
  const textColorObj = {
    0: 'color007',
    1: 'color339',
    2: 'colorEC4',
    3: 'colorF3C',
    Success: 'color339',
    Pending: 'colorFF6',
    Rejected: 'colorEC4',
  };
  const projectId = getProjectId();
  const selectedBusinessGenio = JSON.parse(localStorage.getItem('selectedBusinessGenio'));
  const profile = JSON.parse(sessionStorage.getItem('profileDetails'));
  const ref = useRef(null);

  const handlePincodeTicketCreate = async () => {
    if (isCreatingTicket) return;

    setIsCreatingTicket(true);
    const paramsData = {
      vertical: hasJdMartVertical() ? 'JD MART CORPORATE' : 'LISTING',
      category: 'CS',
      ticket_creator: 'BUSINESS',
      nm:
        projectId === 'csportal'
          ? selectedBusiness?.compname
          : selectedBusinessGenio?.contractPersonName || selectedBusinessGenio?.companyName || '',
      created_by: projectId === 'csportal' ? userDetails?.mobile || '' : profile?.mobile || '',
      mob: projectId === 'csportal' ? userDetails?.mobile || '' : selectedBusinessGenio?.mobile || '',
      issue_type: 'Data changes/validation request',
      issue_sub_type: 'Pincode addition/deletion',
      issue_comment: '',
      document: [],
      city: projectId === 'csportal' ? selectedBusiness?.data_city || '' : selectedBusinessGenio?.city || '',
      oid: '',
      orderid: '',
      docid: projectId === 'csportal' ? selectedBusiness?.docid || '' : selectedBusinessGenio?.docId || '',
      src: projectId === 'csportal' ? 'business' : 'sales-genio',
      src_typ:
        projectId === 'genio' ? (selectedBusinessGenio?.concern === 'client' ? 'client' : 'internal') : 'csportal',
      src_nm: projectId === 'csportal' ? userDetails?.fullName || '' : profile?.full_name || '',
      src_mob: projectId === 'csportal' ? userDetails?.mobile || '' : profile?.mobile || '',
      projectId: projectId === 'csportal' ? 1 : '',
      parentId: projectId === 'csportal' ? selectedBusiness?.parentid || '' : selectedBusinessGenio?.parentId,
      compnm: projectId === 'genio' ? selectedBusinessGenio?.companyName || '' : selectedBusiness?.compname || '',
      source: `description box_support team text_${projectId}`,
      ...(projectId === 'genio' && {
        agent_mngr_id: profile?.reporteeCode,
        agent_id: profile?.empCode,
      }),
    };
    const res = await CreateTicket(paramsData);
    setAlert({
      message: res?.errorCode === 0 ? res.result.msg : res?.result?.msg || 'Something went wrong',
      status: res?.errorCode === 0,
    });
    document.body.style.overflow = 'unset';
    if (projectId === 'csportal') {
      const liVal = 'click';
      const liTrd = `cta_supportteam`;
      const faqTypeVal = '';
      const othersData = [];
      const llTrd = `issue_leads`;
      await handleImpressionsTrack(liVal, liTrd, faqTypeVal, othersData, llTrd, authState);
    }
    handleCloseFeedbackPopup();
  };

  useEffect(() => {
    document.body.style.overflow = 'hidden';
  }, []);

  const handlePopupBtnClick = async (popupBtn) => {
    await clickTracker(
      `${trackerId}_${selectedType}_fix`,
      `leads_${trackerId}${getSubEventType?.[faqId] ? `_${getSubEventType?.[faqId]}` : ''}`,
    );
    if (projectId === 'csportal') {
      const liVal = 'click';
      const liTrd = `cta_${selectedType}_${popupBtn}`;
      const faqTypeVal = '';
      const othersData = [];
      const llTrd = `issue_leads`;
      await handleImpressionsTrack(liVal, liTrd, faqTypeVal, othersData, llTrd, authState);
    }
    handleCloseFeedbackPopup();
    if (selectedType === 'kyc' && !touchSource.includes(source) && !webSource.includes(source)) {
      window.open(popupData?.url, '_blank');
      return;
    }
    if (selectedType === 'kyc') {
      window.location = popupData?.url;
      return;
    }

    handleRedirection(source, popupData?.url || '');
  };

  useClickAwayListener(ref, () => {
    handleCloseFeedbackPopup();
  });

  return (
    <>
      <section className="cs_modal_feedback undefined">
        <div className="cs_modal_feedback_content cs_modal_animation fadeInUpTop" ref={ref}>
          <div className="cs_modal_body p-10">
            <div className="cs_modal_feedback_close mt-10 mr-10">
              {id === 'contract' && (
                <div className="cs_modal_feedback_header font15 text-center fw600 color111 ml-20">
                  <p className="font12 fw500 mr-10">{popupData?.header || ''}</p>
                </div>
              )}
              <div
                tabIndex={0}
                role="button"
                onKeyDown={() => {}}
                style={{ cursor: 'pointer', fontSize: 20 }}
                onClick={() => {
                  document.body.style.overflow = 'unset';
                  handleCloseFeedbackPopup();
                }}
              >
                X
              </div>
            </div>

            <div
              className={
                id === 'feedback' ? 'FeedbackModal_FeedbackModal__Box__BAgpO' : 'FeedbackModal_FeedbackModal__Box__Data'
              }
            >
              {id === 'feedback' ? (
                <>
                  <img
                    alt="thankyou_thumb"
                    className="FeedbackModal_FeedbackModal__BoxImage__JoQYb "
                    src="https://akam.cdn.jdmagicbox.com/images/icontent/newwap/cssupport/thnakyou_thumb.svg"
                  />
                  <div className="font12 fw400 color777 mt-30">Your feedback has been taken</div>
                  <div className="font16 fw600 color111 mt-5 pb-20">Thank you for your feedback!</div>
                </>
              ) : (
                <>
                  {selectedType === 'payment' &&
                    popupData &&
                    popupData?.data &&
                    Object.keys(popupData?.data).length > 0 && (
                      <ul className="p-5">
                        {Object.keys(popupData?.data).map((each, i) =>
                          typeof popupData?.data?.[each].value !== 'object' ? (
                            <li key={i} className="popup-data-content p-10">
                              <h2 className="font12 fw500">{popupData?.data?.[each].text || ''}</h2>
                              <p className={`${textColorObj?.[popupData?.data?.[each].status]} color777 font12 fw500`}>
                                {popupData?.data?.[each].value || ''}
                              </p>
                            </li>
                          ) : (
                            typeof popupData?.data?.[each].value === 'object' && (
                              <div key={i}>
                                <div className="popup-table-div p-10">
                                  <p className="font12 fw500 mt-10">{popupData?.data?.[each].header || ''}</p>
                                </div>
                                {popupData &&
                                  popupData?.data &&
                                  popupData?.data?.[each]?.value &&
                                  popupData?.data?.[each].value &&
                                  Object.keys(popupData?.data?.[each].value).length > 0 && (
                                    <table className="popup-table">
                                      <tbody>
                                        <tr>
                                          <th className="popup-table-th" />
                                          {['Daily', 'Weekly', 'Monthly'].map((colName) => (
                                            <th key={colName} className="popup-table-th font11 fw500">
                                              {colName}
                                            </th>
                                          ))}
                                        </tr>
                                        {popupData?.data?.[each].value &&
                                          Object.keys(popupData?.data?.[each].value).length > 0 &&
                                          Object.keys(popupData?.data?.[each].value).map((eachKey, index) => (
                                            <tr key={index}>
                                              <td className="popup-table-td font11 fw500">{eachKey || ''}</td>
                                              {Object.keys(popupData?.data?.[each]?.value?.[eachKey]).map(
                                                (key, idx) => (
                                                  <td key={idx} className="popup-table-td font11">
                                                    {popupData?.data?.[each]?.value?.[eachKey]?.[key]}
                                                  </td>
                                                ),
                                              )}
                                            </tr>
                                          ))}
                                      </tbody>
                                    </table>
                                  )}
                              </div>
                            )
                          ),
                        )}
                      </ul>
                    )}
                  {selectedType === 'kyc' &&
                    (popupData &&
                    popupData?.data &&
                    popupData?.data[0] &&
                    popupData?.data[0]?.value &&
                    Object.keys(popupData?.data[0]?.value).length > 0 ? (
                      Object.keys(popupData?.data[0]?.value).map((each, i) => {
                        const docObj = popupData?.data?.[0]?.value?.[each] || {};
                        return (
                          <li
                            key={i}
                            className="popup-data-content p-10"
                            style={{
                              justifyContent: 'normal',
                            }}
                          >
                            <div>
                              <h1 className="font12 fw500">{each}</h1>
                            </div>
                            <div className={`${styles.Kyc_Doc_div}`}>
                              {docObj?.status && (
                                <div
                                  // className={`${
                                  //   textColorObj?.[popupData?.data[0]?.value?.[each]?.status]
                                  // } font12 fw500 ml-20`}
                                  // New KYC Logic 19-03-25
                                  className={`${textColorObj?.[docObj?.status]} font12 fw500`}
                                >
                                  {popupData?.data[0]?.value?.[each]?.status || ''}
                                </div>
                              )}
                              {docObj?.text && (
                                <div className={`${docObj?.text === 'Success' ? 'color339 font12' : 'font10 mt-6'}`}>
                                  {docObj?.text !== 'Success' && docObj?.text !== 'Pending' && (
                                    <span className="font10 fw600">Reason: </span>
                                  )}
                                  <span className={`fw500 ${docObj?.text === 'Success' ? 'color339' : 'colorEC4'}`}>
                                    {docObj?.text}
                                  </span>
                                </div>
                              )}
                            </div>
                          </li>
                        );
                      })
                    ) : (
                      <div className="font12 fw500">No Data</div>
                    ))}

                  {selectedType === 'keywords' &&
                    (popupData &&
                    popupData?.data &&
                    popupData?.data[0] &&
                    popupData?.data[0]?.value &&
                    popupData?.data[0]?.value.length > 0 ? (
                      popupData?.data[0].value.map((each, i) => (
                        <li key={i} className="popup-data-content p-10">
                          <h2 className="font12 fw500">{each}</h2>
                        </li>
                      ))
                    ) : (
                      <div className="font12 fw500">No Data</div>
                    ))}

                  {['leadsAndRR', 'contract', 'pincode'].includes(selectedType) &&
                    popupData &&
                    Object.keys(popupData).length > 0 &&
                    popupData?.data &&
                    Object.keys(popupData?.data).length > 0 &&
                    popupData?.data &&
                    popupData?.data.length > 0 &&
                    popupData?.data.map((eachObj, i) => (
                      <React.Fragment key={i}>
                        {((selectedType === 'pincode' &&
                          popupData?.data?.[i]?.value &&
                          Object.keys(popupData?.data?.[i]?.value).length > 0) ||
                          selectedType !== 'pincode') && (
                          <p className="font12 fw500 mt-10">{popupData?.data?.[i]?.header || ''}</p>
                        )}
                        {selectedType === 'pincode' && (
                          <>
                            {popupData?.data?.[i]?.value && Object.keys(popupData?.data?.[i]?.value).length > 0 && (
                              <p className="font12 fw500 mt-10 popup-div-subheader">
                                {popupData?.data?.[i].text || ''}
                              </p>
                            )}
                            <ul className="mt-10">
                              {eachObj?.value &&
                                eachObj?.value.length > 0 &&
                                eachObj?.value.map((item, index) => (
                                  <li key={index} className="popup-data-content-ratings p-10">
                                    <h1 className="font12 fw400">{item || ''}</h1>
                                  </li>
                                ))}
                            </ul>
                          </>
                        )}
                        {selectedType === 'contract' ? (
                          <>
                            {typeof popupData?.data?.[i]?.value !== 'object' ? (
                              <li key={i} className="popup-data-content-ratings p-10">
                                <h2 className="font12 fw500">{eachObj?.text || ''}</h2>
                                <p
                                  className={`font12 fw500 ${
                                    eachObj?.value === 'Available' ? textColorObj[1] : textColorObj[2]
                                  }`}
                                >
                                  {eachObj?.value}
                                </p>
                              </li>
                            ) : (
                              <ul className="mt-10">
                                {popupData?.data?.[i]?.value &&
                                  Object.keys(popupData?.data?.[i]?.value).length > 0 &&
                                  Object.keys(popupData?.data?.[i]?.value).map((item, index) => (
                                    <li key={index} className="popup-data-content-ratings p-10">
                                      <h2 className="font12 fw500">{item || ''}</h2>
                                      <p className="font12 color777 fw500 ml-10">
                                        {popupData?.data?.[i]?.value?.[item] || ''}
                                      </p>
                                    </li>
                                  ))}
                              </ul>
                            )}
                          </>
                        ) : (
                          <>
                            {selectedType !== 'pincode' && (
                              <>
                                {i === 0 ? (
                                  <>
                                    <ul className="mt-10">
                                      <li key={i} className="popup-data-content-ratings p-10">
                                        <h2 className="font12 fw400">{popupData?.data?.[i]?.value?.name || ''}</h2>
                                        <p className="font12 fw400 ml-20">{popupData?.data?.[i]?.value?.reviews}</p>
                                      </li>
                                    </ul>
                                  </>
                                ) : (
                                  <ul className="mt-10">
                                    {Object.keys(popupData.data?.[i]?.value)
                                      .slice(0, 5)
                                      .map((item, index) => (
                                        <li key={index} className="popup-data-content-ratings p-10">
                                          <h2 className="font12 fw400">
                                            {popupData.data?.[i]?.value?.[item]?.name || ''}
                                          </h2>
                                          <p className="font12 fw400 ml-20">
                                            {popupData.data?.[i]?.value?.[item]?.reviews}
                                          </p>
                                        </li>
                                      ))}
                                  </ul>
                                )}
                              </>
                            )}
                          </>
                        )}
                      </React.Fragment>
                    ))}

                  {popupData && popupData?.footer && popupData?.footer !== '' && (
                    <div className="font10 fw500 mt-10">{popupData?.footer || ''}</div>
                  )}
                </>
              )}
            </div>
            {selectedType === 'pincode' ? (
              <div className="font12 fw500 color111 mt-10">
                To edit the pincodes, reach out to our{' '}
                <span
                  tabIndex={0}
                  role="button"
                  onKeyDown={() => {}}
                  style={{
                    pointerEvents: isCreatingTicket ? 'none' : 'auto',
                    opacity: isCreatingTicket ? 0.5 : 1,
                    cursor: isCreatingTicket ? 'not-allowed' : 'pointer',
                  }}
                  onClick={!isCreatingTicket ? handlePincodeTicketCreate : undefined}
                  id="view_tickets"
                >
                  support team
                </span>
              </div>
            ) : (
              projectId === 'csportal' &&
              popupData &&
              popupData?.url &&
              popupData?.btn &&
              popupData?.url !== '' && (
                <div>
                  <button
                    onClick={() => handlePopupBtnClick(popupData?.btn)}
                    className={`${styles.Popup__Btn} ${styles.bluefill_animate} font10 fw500 mt-10`}
                    type="button"
                  >
                    {popupData?.btn || ''}
                  </button>
                </div>
              )
            )}
          </div>
        </div>
      </section>
    </>
  );
}

export default FeedbackPopup;

FeedbackPopup.propTypes = {
  handleCloseFeedbackPopup: PropTypes.func,
  popupData: PropTypes.object,
  id: PropTypes.string,
  selectedType: PropTypes.string,
  faqId: PropTypes.number,
  trackerId: PropTypes.string,
  setAlert: PropTypes.func,
};

FeedbackPopup.defaultProps = {
  popupData: {},
  selectedType: '',
  trackerId: '',
  faqId: null,
};
